import React from 'react';

const MetricWidget = ({ metric, compact = false, isResizable = false }) => {
  if (!metric?.label || metric?.value === undefined) {
    return <div className="text-gray-500 p-4">No metric data available</div>;
  }
  return (
    <div className={`text-center p-4 ${isResizable ? 'h-full flex flex-col justify-center' : ''}`}>
      <div className={`text-3xl font-bold text-blue-600 ${compact ? 'text-2xl' : ''}`}>
        {typeof metric.value === 'number' ? metric.value.toLocaleString() : metric.value}
      </div>
      <div className={`text-gray-600 mt-1 ${compact ? 'text-xs' : 'text-sm'}`}>{metric.label}</div>
      {metric.unit && <div className={`text-gray-400 ${compact ? 'text-xs' : 'text-sm'}`}>{metric.unit}</div>}
      {metric.trend && (
        <div className={`mt-2 inline-flex items-center px-2 py-1 rounded ${
          metric.trend.direction === 'up' ? 'bg-green-100 text-green-800' :
          metric.trend.direction === 'down' ? 'bg-red-100 text-red-800' :
          'bg-gray-100 text-gray-800'
        }`}>
          <span className="font-medium">
            {metric.trend.percentage ? `${metric.trend.percentage}%` : ''}
            {metric.trend.value || ''}
          </span>
          <span className="ml-1">
            {metric.trend.direction === 'up' ? '↑' : metric.trend.direction === 'down' ? '↓' : '→'}
          </span>
          {metric.trend.period && <span className="ml-1 text-xs opacity-75">{metric.trend.period}</span>}
        </div>
      )}
      {metric.comparison && <div className="mt-2 text-xs text-gray-500">{metric.comparison.changeText}</div>}
    </div>
  );
};

export default MetricWidget;